import { useCallback, useContext } from 'react';

import { MatomoContext } from './MatomoContext';
import { TMatomoDataType, TMatomoEventType, TMatomoWindowType, TTriggerEventFunction } from './types';
import { useMatomoPathname } from './useMatotoPathname';

export function triggerEvent(eventName: TMatomoEventType, data: TMatomoDataType = {}) {
  if (window) {
    (window as TMatomoWindowType)?._mtm?.push({ event: eventName, ...data });
  }
}

export function triggerPageview(
  path: string = window.location.href,
  title: string,
  parseProfilePathname: (path: string) => string,
) {
  if ((window as TMatomoWindowType)?._paq) {
    const paq = (window as TMatomoWindowType)._paq;

    if (!title) {
      title = parseProfilePathname(path);
    }

    paq.push(['setCustomUrl', path]);
    paq.push(['setDocumentTitle', title]);
    paq.push(['trackPageView']);
  }
}

export function useMatomo(): { triggerEvent: TTriggerEventFunction; triggerPageView; isInitialized: boolean } {
  const { window } = useContext(MatomoContext);

  const { parseProfilePathname } = useMatomoPathname();

  const triggerEventFunction = useCallback(triggerEvent, [window]);
  const triggerPageViewFunction = useCallback(
    (path: string, title?: string) => triggerPageview(path, title || '', parseProfilePathname),
    [parseProfilePathname],
  );

  return {
    triggerEvent: triggerEventFunction,
    triggerPageView: triggerPageViewFunction,
    isInitialized: (window as TMatomoWindowType)?._paq !== undefined,
  };
}
